<div *ngIf="companyInfo$ | async as companyInfo">
  <p-panel header="Company" styleClass="drill-down-section-header" [toggleable]="true">
    <div *ngIf="hasMultipleDatabases">
      <span class="ey-float-label">
        <select
          class="drill-down-dropdown form-select"
          #companyInfoSelect
          [ngModel]="selectedDatabaseId"
          (change)="onCompanyInfoDatabaseChange(companyInfoSelect.value)"
          appLabelFloat
        >
          <option *ngFor="let database of databases" [value]="database.id">
            {{ database.name }}
          </option>
        </select>
        <label>Database Source</label>
      </span>
    </div>
    <div>
      <p-table styleClass="company-details-table" [value]="[companyInfo]">
        <ng-template pTemplate="body" let-companyInfo>
          <tr class="company-details-row">
            <td class="company-details-label">Company ID:</td>
            <td>
              {{ companyInfo.idNumber }}
            </td>
            <td class="company-details-label">Website:</td>
            <td>
              <a *ngIf="!!companyInfo.webSite" href="{{ companyInfo.webSite | hyperLink }}" rel="noopener noreferrer" target="_blank">
                {{ companyInfo.webSite }}
              </a>
              <span *ngIf="!companyInfo.webSite">
                {{ displayValue(companyInfo.webSite) }}
              </span>
            </td>
          </tr>
          <tr class="company-details-row">
            <td class="company-details-label">Type Of Company:</td>
            <td>
              {{ companyInfo.type }}
            </td>
            <td class="company-details-label">Stock Exchange:</td>
            <td>
              {{ displayValue(companyInfo.stockExchange) }}
            </td>
            <td class="company-details-label">Address:</td>
            <td>
              {{ displayValue(companyInfo.address) }}
            </td>
          </tr>
          <tr class="company-details-row">
            <td class="company-details-label">Ticker Symbol:</td>
            <td>
              {{ displayValue(companyInfo.tickerSymbol) }}
            </td>
            <td class="company-details-label">Year Of Incorporation:</td>
            <td>
              {{ displayValue(companyInfo.yearIncorporated) }}
            </td>
            <td class="company-details-label">Telephone:</td>
            <td>
              {{ displayValue(companyInfo.phone) }}
            </td>
          </tr>
          <tr class="company-details-row">
            <td class="company-details-label">Fn. Stmt. Type:</td>
            <td>
              {{ displayValue(isNonBvd ? '' : companyInfo.financialType) }}
            </td>
            <td class="company-details-label">Status:</td>
            <td>
              {{ companyInfo.status }}
            </td>
            <td class="company-details-label">Segmented Financials:</td>
            <td>
              {{ companyInfo.segmentedFinancials ? 'Yes' : 'No' }}
            </td>
          </tr>
          <tr class="company-details-row">
            <td class="company-details-label" *ngIf="!isNonBvd">Independence Indicator:</td>
            <td *ngIf="!isNonBvd">
              {{ displayValue(companyInfo.independenceIndicator) }}
            </td>
            <td class="company-details-label" *ngIf="isOneSource">Annual Report:</td>
            <td *ngIf="isOneSource">
              <a [href]="oneSourceUrl(companyInfo.idNumber)" rel="noopener noreferrer" target="_blank">OneSource</a>
            </td>
            <td class="company-details-label" *ngIf="isOneSource">10K:</td>
            <td *ngIf="isOneSource">
              <a [href]="secUrl(companyInfo.cik)" rel="noopener noreferrer" target="_blank">SEC</a>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </p-panel>
</div>
